/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFitHeight = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m16.231 14.36 1.537 1.28L14.135 20H20v2H4v-2h5.864l-3.632-4.36 1.537-1.28 4.23 5.077zM20 2v2h-5.865l3.634 4.36-1.537 1.28L12 4.563 7.768 9.641 6.231 8.36 9.864 4H4V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgFitHeight as FitHeight };
